import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { PipesModule } from '../../pipes/pipes.module';
import { GetLanguageService } from '../../services/translations/translations.service';
import { MatMenuModule } from '@angular/material/menu';
import { EmojiComponent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { ConfigService } from '../../services/config/config.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-language-switcher',
		standalone: true,
  imports: [
		CommonModule,
		FormsModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		PipesModule,
		MatMenuModule,
		EmojiComponent,
		TranslateModule
	],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss'
})
export class LanguageSwitcherComponent {

	@Input() textColorWhite: boolean = false;
	@Input() hoverDisabled: boolean = false;
	@Input() showAbbreviation: boolean = true;
	availableLanguages: string[]= [];

	countryFlagOverride: { [key: string]: string } = {
		'en': 'us',
		'zh': 'cn',
		'uk': 'ua',
		'ka': 'ge',
		'ko': 'kr',
		'ar': 'ae',
		'bn': 'bd'
	}

	constructor(
		public getLanguageService: GetLanguageService,
		private configService: ConfigService
	) {}

	async ngOnInit(): Promise<void> {
		this.availableLanguages = this.configService.getTenantLanguages().filter(Boolean);
	}

	changeLanguage(language: string) {
		if (!language) {
			return;
		}

		this.getLanguageService.setLanguage(language);
	}
}
